import BIObject from '@/types/taxcard/BIObject';
import { ArrayNotEmpty, IsNumber } from 'class-validator';
import { GuestTypesEnum } from './GuestType';

export default class Booking {
  @IsNumber()
  public communeId: number;

  // public isAnonymous: boolean;

  public strictAccommodation: boolean;

  public communeMailConsent: boolean;

  @ArrayNotEmpty()
  public bIObjects: BIObject[];

  public constructor(communeId?: number, bIObjects?: BIObject[], strictAccommodation?: boolean, communeMailConsent?: boolean) {
    this.communeId = communeId || 0;
    this.bIObjects = bIObjects || [];
    // NOTE: strictAccommodation will disable the select accommodation button.
    // It is being activated on accommodation deep links if the commune enabled strict accommodation selection.
    this.strictAccommodation = strictAccommodation || false;
    this.communeMailConsent = communeMailConsent || false;
  }

  public get isAnonymous() : boolean {
    if (this.bIObjects.length == 1) {
      return this.bIObjects[0].bIObjectData.isAnonymous;
    }
    return false;
  }

  public addBIObject(bIObject: BIObject): void {
    this.bIObjects = [...this.bIObjects, bIObject];
  }

  public isDonation(): boolean {
    if (this.bIObjects.length == 1) {
      return this.bIObjects[0].bIObjectData.guestType == GuestTypesEnum.donation;
    }
    return false;
  }

  public dehydrate(): string {
    return JSON.stringify(this);
  }

  public static hydrate(json: string): Booking | null {
    const data = JSON.parse(json);
    if (!data) {
      return null;
    }
    const { bIObjects, communeId, strictAccommodation, communeMailConsent } = data;
    return new Booking(
      communeId,
      bIObjects && bIObjects.map((bIObject: any) => BIObject.hydrate(bIObject) || []),
      strictAccommodation,
      communeMailConsent
    );
  }
}
